import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Paper,
  Fade,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";

import Layout from "../../components/Layout";
import apiClient from "../../services/apiClient";

const MastersList: React.FC = () => {
  const [serviceMasters, setServiceMasters] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMasters = async () => {
      try {
        setLoading(true);
        const data = await apiClient<any>("v1/resource/master_type/all");
        setServiceMasters(data?.data?.master_types || []);
      } catch (error) {
        console.error("Failed to fetch masters:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMasters();
  }, []);

  if (loading) {
    return (
      <Layout>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress size={50} />
        </Box>
      </Layout>
    );
  }

  return (
    <Layout>
      <Box sx={{ p: 3 }}>
        {serviceMasters.length === 0 ? (
          <Paper
            elevation={0}
            sx={{
              p: 4,
              textAlign: "center",
              borderRadius: 3,
              bgcolor: "grey.50",
            }}
          >
            <InfoIcon sx={{ fontSize: 40, color: "text.secondary", mb: 1 }} />
            <Typography variant="body1" color="text.secondary">
              No service masters found.
            </Typography>
          </Paper>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            {serviceMasters.map((service, index) => (
              <Fade in timeout={500 + index * 100} key={service?.slug}>
                <Card
                  onClick={() => navigate(`/masters/${service?.slug}`)}
                  sx={{
                    flex: "1 1 calc(20% - 16px)",
                    minWidth: 180,
                    borderRadius: 3,
                    boxShadow: 3,
                    transition: "transform 0.2s, box-shadow 0.2s",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "translateY(-3px)",
                      boxShadow: 6,
                    },
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: "bold",
                        textTransform: "capitalize",
                        mb: 1,
                      }}
                    >
                      {service?.slug?.replace(/[-_]/g, " ")}
                    </Typography>
                  </CardContent>
                </Card>
              </Fade>
            ))}
          </Box>
        )}
      </Box>
    </Layout>
  );
};

export default MastersList;
